<template>
  <div>
    <b-card title="منو جدید">
      <b-card-text>
        <div>
          <b-form @submit="onSubmit" v-if="show">
            <b-row>
              <b-col>
                <b-form-group
                  id="input-group-2"
                  label="عنوان منو:"
                  label-for="input-2"
                >
                  <b-form-input
                    id="input-2"
                    v-model="form.title"
                    required
                    placeholder="عنوان منو"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  id="input-group-2"
                  label="آدرس منو:"
                  label-for="input-2"
                >
                  <b-form-input
                    id="input-2"
                    v-model="form.url"
                    required
                    placeholder="آدرس منو"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  id="input-group-3"
                  label="ایکن منو:"
                  label-for="input-3"
                >
                  <b-form-input
                    id="input-3"
                    v-model="form.icon"
                    required
                    placeholder="ایکن منو"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  id="input-group-4"
                  label="ترتیب نمایش:"
                  label-for="input-4"
                >
                  <b-form-input
                    id="input-4"
                    v-model="form.row_order"
                    required
                    placeholder="ترتیب نمایش"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  id="input-group-4"
                  label="منوی والد:"
                  label-for="input-4"
                >
                  <treeselect
                    v-model="form.parent_id"
                    :options="options"
                      :normalizer="normalizer"
                      placeholder="لطفا انتخاب کنید"
                  />
                </b-form-group>
              </b-col>
              <b-col> </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-table responsive striped :items="form.roles" :fields="RoleFields">
                  <template v-slot:cell(on_list)="data">
                    <b-form-checkbox
                      v-model="data.item.on_list"
                    ></b-form-checkbox>
                  </template>
                  <template v-slot:cell(on_create)="data">
                    <b-form-checkbox
                      v-model="data.item.on_create"
                    ></b-form-checkbox>
                  </template>
                  <template v-slot:cell(on_edit)="data">
                    <b-form-checkbox
                      v-model="data.item.on_edit"
                    ></b-form-checkbox>
                  </template>
                  <template v-slot:cell(on_delete)="data">
                    <b-form-checkbox
                      v-model="data.item.on_delete"
                    ></b-form-checkbox>
                  </template>
                </b-table>
              </b-col>
            </b-row>

            <b-button type="submit" variant="primary">ذخیره</b-button>
            <b-button href="#/users" variant="danger">بازگشت</b-button>
          </b-form>
        </div>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelpoer from "@/helpers/httpHelper";
import sessionHelper from "../../helpers/sessionHelper";
import httpHelper from "../../helpers/httpHelper";
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  name: "addUser",
  components: {
    Treeselect,
  },
  data() {
    return {
      form: {
        title: "",
        url: "",
        icon: "",
        row_order: 0,
        role_id: 0,
        roles: [],
        parent_id: null,
      },
      
      options: [],
      roles: [],
      show: true,
      RoleFields: [
        {
          key: "name",
          label: "عنوان",
        },
        {
          key: "on_list",
          label: "نمایش لیست",
        },
        {
          key: "on_create",
          label: "جدید",
        },
        {
          key: "on_edit",
          label: "ویرایش",
        },
        {
          key: "on_delete",
          label: "حذف",
        },
      ],
    };
  },
  created() {
    httpHelpoer.setAuth();
    httpHelpoer
      .getData("role")
      .then((res) => {
        this.form.roles = res.result.map((element) => {
          return {
            role_id: element.id,
            name: element.name,
            on_list: false,
            on_create: false,
            on_edit: false,
            on_delete: false,
          };
        });
        console.log(this.form.roles);
      })
      .finally(() => {});
    this.getTreeMenu();
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      httpHelper.setAuth();
      httpHelper.postData("menu", this.form).then((res) => {
        this.$router.push("rp/4");
      });
    },
    getTreeMenu() {
      httpHelper.setAuth();

      httpHelpoer
        .getData("gettreemenu")
       .then((res) => {
        this.options = res.result.map((element) => {
            if(element.children.length) {
          return {
            id: element.id,
            title: element.title,
            children: element.children,

          };
            }else {
                 return {
            id: element.id,
            title: element.title,
          };
            }
        });
        console.log(this.form.roles);
      })
      .finally(() => {});
    },
    normalizer(node) {
      return {
        id: node.id,
        label: node.title,
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "لیست منوها",
        route: "/rp/4",
      },
      {
        title: "منوی جدید",
      },
    ]);
  },
};
</script>
